import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { ApplyPipeModule, CalendarPickerModule, CopyToClipboardModule  } from 'ngx-zcs-components';
import { MatChipsModule } from '@angular/material/chips';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { IonicModule } from '@ionic/angular';

import { DeviceListComponent } from './device-list.component';
import { BlockTitleComponent } from '../components/block-title/block-title.component';

@NgModule({
  declarations: [
    DeviceListComponent,
  ],
  imports: [
    ApplyPipeModule,
    BlockTitleComponent,
    CalendarPickerModule,
    CommonModule,
    CopyToClipboardModule,
    IonicModule,
    MatCheckboxModule,
    MatChipsModule,
    MatIconModule,
    MatInputModule,
    MatSortModule,
    MatTableModule,
  ],
  exports: [
    DeviceListComponent,
  ],
})
export class DeviceListModule { }
